import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { programPdfdownloadReq } from '@utils/http'
import { cloudfrontPath } from '@utils/image'

type Props = {
  programId: number
  programName: string
}

export const PdfDownload = ({ programId, programName }: Props): JSX.Element => {
  return (
    <div className="md:py-[0.8vw] rounded-[20px] border border-[#999999] lg:hover:opacity-50">
      <button
        className="flex justify-center w-full"
        onClick={() => programPdfdownloadReq(programId, programName)}
      >
        <div className="flex flex-row justify-center items-center">
          <div className="md:w-[1.4vw]">
            <ImageWraper
              src={`${cloudfrontPath}/programs/icons/program-detail/pdf.svg`}
              width={18}
              height={20}
              alt="pdfダウンロードのアイコン"
            />
          </div>
          <div className="md:ml-[0.8vw]">
            <div className="md:text-[1.3vw] text-[#666666]">
              印刷・資料用に保存
            </div>
          </div>
        </div>
      </button>
    </div>
  )
}
